<template>
  <section class="section">
    <div class="container">
      <div class="row">
          <div class="col-md-12 text-center">
            <h3 class="text-brand">
            <b>En Andalepide nos interesa mucho tu opinión, esto nos ayuda a mejorar día a día.
            <br/>Es por esto que te dejamos una breve encuesta para que completes, solo te tomará un minuto</b></h3>
          </div>
      </div>     
      <div class="panel-group">
        <div class="row" v-for="(campaign, idx) in campaigns" :key="campaign._id">
            <div class="row">
              <div class="col-md-12 text-center">
                <h4 class="text-primary" v-if="campaigns.length>1"><b>Encuesta {{idx + 1}} de {{campaigns.length}}</b></h4>
              </div>
            </div>
            <div class="row" v-for="seccion in campaign.sections" :key="seccion.seccion">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h4 class="text-primary"><b>{{seccion.seccion}}</b></h4>
                  </div>
                </div>
                <div class="row" v-for="pregunta in seccion.preguntas">
                  <div class="row text-center">
                    <h4>{{pregunta.pregunta}}</h4>
                  </div>
                  <div class="row text-center">
                    <div v-if="pregunta.tipo=='Rating'" :key="pregunta._id" class="rating-control">
                        <i class="fa fa-3x fa-smile-o" :key="campaign._id + pregunta._id + '3'" v-bind:class="{ selected: 
                        pregunta.respuestaNumero==3 }" @click="setValue(pregunta, 3)"></i>
                        <i class="fa fa-3x fa-meh-o"  :key="campaign._id + pregunta._id + '2'" v-bind:class="{ selected: pregunta.respuestaNumero==2 }" @click="setValue(pregunta, 2)"></i>
                        <i class="fa fa-3x fa-frown-o" :key="campaign._id + pregunta._id + '1'" v-bind:class="{ selected: pregunta.respuestaNumero==1 }" @click="setValue(pregunta, 1)"></i>                        
                    </div>
                    <div v-if="pregunta.tipo=='Texto'" class="row">
                        <div class="col-md-6 col-md-offset-3 col-xs-12 col-sm-12">
                          <textarea v-model="pregunta.respuestaString" class="form-control" rows="10"></textarea>
                        </div>
                    </div>
                  </div>
                </div>
            </div>     
        
        <div class="row answer-campaign-button">
          <div class="col-md-12 text-center">
            <button @click="answerCampaign(campaign, idx)" class="btn btn-fill" type="button">Responder</button>
          </div>
        </div>
        </div>     
      </div>
    </div>
  </section>
</template>
<script>
import moment from 'moment'
import { groupBy, sortBy } from 'lodash'

moment.locale('es')

export default {
  props: ['user'],
  computed: {
  },
  data () {
    return {
      currentSection: '',
      campaigns: [],
      page: 0,
      offset: 0,
      loading: false
    }
  },
  filters: {
    formatearFecha (value) {
      return moment(new Date(value)).format('DD/MM/YYYY')
    }
  },
  methods: {
    isValid (camp) {
      let valid = true
      camp.preguntas.forEach((preg) => {
        if (preg.tipo === 'Rating' && !preg.respuestaNumero) {
          valid = false
        }
      })
      return valid
    },
    answerCampaign (camp, idx) {
      const me = this
      if (me.isValid(camp)) {
        me.$http.post('/api/users/campaign/answer', {
          campaign: camp
        }).then(({body}) => {
          me.campaigns.splice(idx, 1)
          this.$emit('mostrar-notificacion', 'Gracias por participar! Su opinión nos ayuda a mejorar', 'success')
          if (me.campaigns.length === 0) {
            me.$emit('user-loggged')
          }
        }, (err) => {
          console.error(err)
        })
      } else {
        this.$emit('mostrar-notificacion', 'Debe responder todas las preguntas para poder continuar', 'warning')
      }
    },
    setValue (pregunta, value) {
      pregunta.respuestaNumero = value
      this.$forceUpdate()
    },
    cargar () {
      const me = this
      me.loading = true
      me.$http.get('/api/admin/campaigns', {page: me.page, offset: me.offset}).then(({body}) => {
        me.campaigns = body.campaigns
        me.loading = false
      }, (err) => {
        me.loading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    }
  },
  mounted () {
    const me = this
    me.$http.get('/api/users/me').then(({body}) => {
      body.needsToAnswerCampaign.forEach((camp) => {
        camp.preguntas = sortBy(camp.preguntas, 'orden')
        let sections = groupBy(camp.preguntas, 'seccion')
        camp.sections = []
        let curSect
        camp.preguntas.forEach((preg) => {
          if (!curSect || preg.seccion !== curSect) {
            camp.sections.push({seccion: preg.seccion, preguntas: sections[preg.seccion]})
            curSect = preg.seccion
          }
        })
      })
      me.campaigns = body.needsToAnswerCampaign
    })
  },
  watch: {
  }
}
</script>
<style scoped>
.modal {
  background-color: white;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #F28893;
  color: #333;
}
.status-cocina {
  background-color: #FFC182;
  color: #333;
}
.status-empaquetado {
  background-color: #74A9B3;
  color: #333;
}
.status-entregado {
  background-color: #93A512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// Answer.vue?397907d0